<script lang="ts" setup>
import { computed, PropType } from "vue";
import { PoolDetails } from "@/models/pool-details.model";
import KlereoSegmentedControl from "@/shared/components/KlereoSegmentedControl.vue";

const props = defineProps({
  out: Object as PropType<PoolDetails["outs"][number]>,
});

const emit = defineEmits(["change"]);

const options = [
  { value: "0", label: "OFF" },
  { value: "1", label: "ON" },
];

const selected = computed(() => String(props.out?.status === 1 ? 1 : 0));
</script>

<template>
  <KlereoSegmentedControl
    :model-value="selected"
    :options="options"
    @update:model-value="emit('change', Number($event))"
  />
</template>
